const AbstractSettingsDelegate = require("settings/AbstractSettingsDelegate");
const Utils = require("common/Utils");

function DownloadsSettingsDelegate(clientConfig, listView, vpnConfigDownloadsView) {
    AbstractSettingsDelegate.call(this);

    const self = this;
    var currentView = listView;
    var currentVpnConfig;

    const vpnConfigSettings = {};
    vpnConfigSettings[clientConfig.browser.OS.MACOSX] = {type : "multiple", message : $.t("web::vpnConfig.message.multiple")};
    vpnConfigSettings[clientConfig.browser.OS.IOS] = {type : "mobileconfig", message : $.t("web::vpnConfig.message.mobileconfig")};
    vpnConfigSettings[clientConfig.browser.OS.WINDOWS] = {type : "vpnfile", message : $.t("web::vpnConfig.message.vpnfile", {vpnProductName : Utils.getVpnProductName()})};

    const vpnOsSettings = vpnConfigSettings[clientConfig.browser.getOS()];

    if (vpnOsSettings) {
        listView.setVpnConfigurationMessage(vpnOsSettings.message);

        $(document).on("resourceslistchange", function(event, resources) {
            var vpnConnections = filterVpnConfigs(resources);
            listView.setVpnConfigurations(vpnConnections, vpnOsSettings.type);
        });
    }

    function filterVpnConfigs(resources) {
        return Utils.objectFilter(resources, function(res) {
            return res.type === "vpn_connection" && res.readonly && (!res.hasOwnProperty("launchable") || res.launchable === true);
        }) || [];
    }

    /**
     * @override
     * @inheritDoc
     */
    this.getId = function() {
        return "DownloadsSettingsDelegate";
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getLabel = function() {
        return $.t("web::downloads.title");
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getViews = function() {
        return [listView, vpnConfigDownloadsView];
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getTopLevelViews = function() {
        return [listView];
    };

    function changeView(view) {
        if (view.getHashName() === listView.getHashName()) {
            currentVpnConfig = undefined;
        }
        currentView = view;
        self.showView(view);
    }

    /**
     * @override
     * @inheritDoc
     */
    this.setMenuEntry = function(entry) {
        entry.on("click", function() {
            changeView(listView);
        });
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getState = function() {
        if (currentView) {
            const state = {view : currentView.getHashName()};

            if (currentVpnConfig) {
                state.configId = currentVpnConfig.id;
            }
            return state;
        }
    };

    /**
     * @override
     * @inheritDoc
     */
    this.setState = function(state) {
        if (state.view) {
            if (state.view === vpnConfigDownloadsView.getHashName() && state.configId) {
                CudaLaunch.models.resources.getGuaranteedResources()
                    .then(function() {
                        currentVpnConfig = CudaLaunch.models.resources.getResource(state.configId);

                        if (currentVpnConfig) {
                            self.publishEvent(self.getId(), "show-vpn-downloads", {resource : currentVpnConfig});
                        } else {
                            var onClose = function() {
                                // The config is no longer available so go back to list view
                                changeView(listView);
                            };

                            CudaLaunch.controllers.RootController.showErrorDialog($.t("web::vpnConfig.download.unavailable"), false, undefined, onClose);
                        }
                    });
            } else {
                changeView(listView);
            }
        }
    };

    this.subscribeToChannel("DownloadsSettingsDelegate", "show-vpn-downloads", function(data) {
        currentVpnConfig = data.resource;
        vpnConfigDownloadsView.setResource(currentVpnConfig);
        changeView(vpnConfigDownloadsView);
    });
}

Utils.inherits(DownloadsSettingsDelegate, AbstractSettingsDelegate);

module.exports = DownloadsSettingsDelegate;


//////////////////
// WEBPACK FOOTER
// ./downloads/DownloadsSettingsDelegate.js
// module id = 101
// module chunks = 0